module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0039.jpg?v=78a57470";